import { cn } from '../../../utils/cn';
import { Spinner } from '../Spinner/Spinner';
import styles from './PageLoader.module.css';

export interface PageLoaderProps {
  message?: string;
  fullscreen?: boolean;
}

export function PageLoader({ message, fullscreen = false }: PageLoaderProps) {
  return (
    <div className={cn(styles.shell, fullscreen && styles.fullscreen)} role="status">
      <span className={styles.spinnerWrap}>
        <Spinner size="lg" label={message ?? 'Loading'} />
      </span>
      {message ? <p className={styles.message}>{message}</p> : null}
    </div>
  );
}
